module.exports = __webpack_public_path__ + "img/competitorAnalysis.26c396e1.png";